/**
 * 第三方查看隐私协议
 * 适用于：扫描手环二维码查看信息的第三方
 */

export default function ThirdPartyPrivacyPage() {
  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4">
      <div className="max-w-3xl mx-auto bg-white rounded-lg shadow-md p-8">
        <h1 className="text-3xl font-bold text-gray-800 mb-6 text-center">
          第三方查看隐私协议
        </h1>

        <div className="text-sm text-gray-500 mb-2 text-center">
          适用对象：扫描手环二维码查看信息的第三方
        </div>
        <div className="text-sm text-gray-500 mb-8 text-center">
          生效日期：2025年12月30日
        </div>

        <div className="space-y-6 text-gray-700">
          {/* 引言 */}
          <section className="bg-red-50 p-4 rounded-lg border-2 border-red-200">
            <p className="font-bold text-red-900 mb-2">
              ⚠️ 重要声明
            </p>
            <p>
              感谢您的善意帮助！您即将查看的信息属于佩戴者的个人隐私，
              受到法律保护。请在阅读并同意本协议后再继续查看。
              <strong className="text-red-600">违反本协议可能承担法律责任。</strong>
            </p>
          </section>

          {/* 第一条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">一、适用场景</h2>
            <div className="space-y-2">
              <p>
                1.1 本协议适用于所有通过扫描老人守护手环二维码查看佩戴者信息的个人或组织。
              </p>
              <p>
                1.2 查看信息即表示您同意接受本协议的全部约束。
              </p>
            </div>
          </section>

          {/* 第二条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">二、信息使用规则</h2>
            <div className="space-y-3 bg-blue-50 p-4 rounded-lg">
              <p className="font-bold text-blue-900">
                ✓ 您可以：
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>在紧急情况下联系佩戴者的紧急联系人</li>
                <li>向医护人员提供佩戴者的医疗信息以协助救治</li>
                <li>协助走失的佩戴者回家</li>
                <li>在征得佩戴者或其家属同意后使用相关信息</li>
              </ul>
            </div>

            <div className="space-y-3 bg-red-50 p-4 rounded-lg mt-3">
              <p className="font-bold text-red-900">
                ✗ 您不得：
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li><strong>商业用途</strong>：将信息用于任何商业目的，包括但不限于推销、广告等</li>
                <li><strong>传播泄露</strong>：向他人泄露、转发、公开发布或以任何方式传播这些信息</li>
                <li><strong>截图保存</strong>：长期保存或截图留存这些信息（紧急情况除外）</li>
                <li><strong>骚扰诈骗</strong>：利用这些信息骚扰、威胁或诈骗佩戴者及其家属</li>
                <li><strong>其他滥用</strong>：以任何可能侵害佩戴者权益的方式使用信息</li>
              </ul>
            </div>
          </section>

          {/* 第三条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">三、信息保密义务</h2>
            <div className="space-y-2">
              <p>
                3.1 您承诺对查看到的所有个人信息严格保密，除紧急情况外，
                不向任何第三方透露。
              </p>
              <p>
                3.2 如您因帮助佩戴者而获知了其他未公开的信息（如家庭住址等），
                同样负有保密义务。
              </p>
              <p>
                3.3 在紧急情况结束后，您应删除或销毁所有保存的佩戴者信息。
              </p>
            </div>
          </section>

          {/* 第四条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">四、法律责任</h2>
            <div className="space-y-2 bg-yellow-50 p-4 rounded-lg">
              <p className="font-bold text-amber-900">
                违反本协议可能承担以下责任：
              </p>
              <p>
                4.1 <strong>民事责任</strong>：如因您违反本协议导致佩戴者或其家属遭受损失，
                您需承担赔偿责任。
              </p>
              <p>
                4.2 <strong>行政责任</strong>：违反《中华人民共和国个人信息保护法》等法律法规的，
                可能受到行政处罚。
              </p>
              <p>
                4.3 <strong>刑事责任</strong>：情节严重的（如利用信息实施诈骗、敲诈勒索等），
                可能构成犯罪，依法追究刑事责任。
              </p>
            </div>
          </section>

          {/* 第五条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">五、特殊情况说明</h2>
            <div className="space-y-2">
              <p className="font-medium">5.1 医护人员</p>
              <p className="ml-4">
                如您是医护人员，在救治过程中可以使用佩戴者的医疗信息，
                但在救治完成后仍需遵守医疗保密规定。
              </p>
              <p className="font-medium mt-3">5.2 执法人员</p>
              <p className="ml-4">
                如您是执法人员，可以依法使用这些信息协助调查或救助，
                但仍需按照相关法律法规保护个人隐私。
              </p>
            </div>
          </section>

          {/* 第六条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">六、善意帮助免责</h2>
            <div className="space-y-2 bg-green-50 p-4 rounded-lg">
              <p className="font-bold text-green-900">
                ✓ 善意帮助保护
              </p>
              <p>
                6.1 如您出于善意帮助佩戴者（如协助走失老人回家、紧急情况下联系家属等），
                即使在帮助过程中因不可预见的原因造成了轻微损害，您也<strong>不承担法律责任</strong>。
              </p>
              <p>
                6.2 这符合《中华人民共和国民法典》第一百八十四条"因自愿实施紧急救助行为造成受助人损害的，
                救助人不承担民事责任"的规定。
              </p>
              <p className="text-sm text-gray-600 mt-2">
                注：但故意或重大过失除外。
              </p>
            </div>
          </section>

          {/* 第七条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">七、平台责任限制</h2>
            <div className="space-y-2">
              <p>
                7.1 守护环科技有限公司（平台运营方）仅提供信息展示平台，
                不对第三方的行为承担责任。
              </p>
              <p>
                7.2 如发现有人滥用信息，请及时举报：report@h.blet.cc
              </p>
            </div>
          </section>

          {/* 第八条 */}
          <section>
            <h2 className="text-xl font-bold text-gray-800 mb-3">八、适用法律</h2>
            <div className="space-y-2">
              <p>
                本协议适用中华人民共和国法律，特别是：
              </p>
              <ul className="list-disc list-inside ml-4 space-y-1">
                <li>《中华人民共和国民法典》</li>
                <li>《中华人民共和国个人信息保护法》</li>
                <li>《中华人民共和国网络安全法》</li>
              </ul>
            </div>
          </section>

          {/* 温馨提示 */}
          <section className="bg-gradient-to-r from-blue-50 to-purple-50 p-6 rounded-lg border-2 border-blue-200">
            <h3 className="font-bold text-blue-900 mb-3 flex items-center">
              <span className="text-2xl mr-2">🙏</span>
              感谢您的善意
            </h3>
            <p className="text-gray-700">
              每一次帮助都可能挽救一个家庭的焦急等待。
              我们相信，大多数人都是善良的。
              请您在查看信息时保持善意，在帮助他人的同时也保护好他们的隐私。
            </p>
            <p className="text-gray-700 mt-2">
              如果您发现佩戴者需要帮助，请不要犹豫，立即联系其紧急联系人或拨打 120 / 110。
            </p>
          </section>
        </div>

        {/* 底部 */}
        <div className="mt-10 pt-6 border-t text-center">
          <button
            onClick={() => window.close()}
            className="text-blue-600 hover:underline mr-4"
          >
            关闭窗口
          </button>
          <button
            onClick={() => window.history.back()}
            className="text-blue-600 hover:underline"
          >
            返回上一页
          </button>
        </div>
      </div>
    </div>
  )
}
